
import { IEnvironment, environmentGlobal } from "./environment.global";

export const environment: IEnvironment = {
    name: 'dev',
    production: true,
    enterprise: environmentGlobal.enterprise,
    deviceFuncMap: environmentGlobal.deviceFuncMap
};